/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getGenderByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetGenderById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getGenderByIdIdRegExpTwo)]).optional()
});

export type GetGenderById = zod.input<typeof GetGenderById>;
export type GetGenderByIdOutput = zod.output<typeof GetGenderById>;
